/**
 * @generated SignedSource<<92a45c424edd42d8fb867ab822ff9730>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type SpaceInviteInput_data$data = {
  readonly " $fragmentSpreads": FragmentRefs<"RolePicker_data" | "SpacePicker_data">;
  readonly " $fragmentType": "SpaceInviteInput_data";
};
export type SpaceInviteInput_data$key = {
  readonly " $data"?: SpaceInviteInput_data$data;
  readonly " $fragmentSpreads": FragmentRefs<"SpaceInviteInput_data">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cloudId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "tenantId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "name": "SpaceInviteInput_data",
  "selections": [
    {
      "args": [
        (v0/*: any*/),
        {
          "kind": "Variable",
          "name": "tenantId",
          "variableName": "tenantId"
        },
        {
          "kind": "Variable",
          "name": "userId",
          "variableName": "userId"
        }
      ],
      "kind": "FragmentSpread",
      "name": "SpacePicker_data"
    },
    {
      "args": [
        (v0/*: any*/)
      ],
      "kind": "FragmentSpread",
      "name": "RolePicker_data"
    }
  ],
  "type": "Query"
};
})();

(node as any).hash = "0d8ce1269490597cc1e9d1dd97076dfd";

export default node;
